export const appointments = [
  {
    tenantId: 'TNT-48291',
    domain: 'appointment',
    eventId: 'APT-01009',
    patientId: 'P67891',
    internalStatus: 'Active',
    status: 'booked',
    start: new Date('2025-09-28T09:30:00+12:00'),
    end: new Date('2025-09-28T10:15:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-102',
      study: 'Cardiac Rehabilitation',
      subStudy: 'Outcomes Measurement',
      patientName: 'Michael Rodriguez',
      clinicianName: 'Dr. Lisa Williams',
      location: 'South Clinic',
      type: 'Follow-up',
      description: 'Post-procedure evalu...',
      notes: 'Three month follow-up aft...',
    },
  },
  {
    tenantId: 'TNT-59302',
    domain: 'appointment',
    eventId: 'APT-01004',
    patientId: 'P24680',
    internalStatus: 'Pending',
    status: 'completed',
    start: new Date('2025-09-26T15:45:00+12:00'),
    end: new Date('2025-09-26T16:15:00+12:00'),
    context: {
      // projectId: "ZEDOC-2023-078",
      study: 'Diabetes Management',
      subStudy: 'Lifestyle Intervention',
      // patientName: 'Patient Unknown',
      clinicianName: 'Dr. James Wilson',
      location: 'Telehealth',
      type: 'Follow-up',
      // description: "Medication review for...",
      notes: 'Patient reports improved ...',
    },
  },
  {
    tenantId: 'TNT-12877',
    domain: 'appointment',
    eventId: 'APT-01099',
    patientId: 'P24680',
    internalStatus: 'Pending',
    status: 'completed',
    start: new Date('2025-09-03T08:45:00+12:00'),
    end: new Date('2025-09-03T09:05:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-078',
      study: 'Diabetes Management',
      subStudy: 'Lifestyle Intervention',
      patientName: 'William Taylor',
      clinicianName: 'Dr. James Wilson',
      location: 'Telehealth',
      type: 'Follow-up',
      // description: "Medication review for...",
      notes: 'Patient reports improved ...',
    },
  },
  {
    tenantId: 'TNT-93451',
    domain: 'appointment',
    eventId: 'APT-01001',
    // patientId: "P12345",
    internalStatus: 'Pending',
    status: 'booked',
    start: new Date('2025-09-08T09:30:00+12:00'),
    end: new Date('2025-09-08T14:00:00+12:00'),
    context: {
      // projectId: "ZEDOC-2023-045",
      study: 'Hypertension Study',
      subStudy: 'Initial Screening',
      patientName: 'John Smith',
      clinicianName: 'Dr. Sarah Johnson',
      location: 'Main Campus',
      type: 'Follow-up',
      description: 'Annual check-up with...',
      notes: 'Patient has requested a p...',
    },
  },
  {
    tenantId: 'TNT-22763',
    domain: 'appointment',
    eventId: 'APT-01007',
    patientId: 'P24601',
    internalStatus: 'Active',
    status: 'canceled',
    start: new Date('2025-09-09T10:15:00+12:00'),
    end: new Date('2025-09-09T11:15:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-078',
      study: 'Diabetes Management',
      subStudy: 'Final Evaluation',
      patientName: 'Jennifer Martinez',
      clinicianName: 'Dr. Michael Brown',
      location: 'North Clinic',
      type: 'Follow-up',
      description: 'Final evaluation for...',
      notes: 'Patient will complete fin...',
    },
  },
  {
    tenantId: 'TNT-71945',
    domain: 'appointment',
    eventId: 'APT-02010',
    patientId: 'P31234',
    internalStatus: 'Active',
    status: 'no-show',
    start: new Date('2025-09-09T11:30:00+12:00'),
    end: new Date('2025-09-09T12:00:00+12:00'),
    context: {
      projectId: 'ZEDOC-2024-055',
      study: 'Mental Health Trial',
      subStudy: 'Preliminary Interview',
      patientName: 'Sophie Bennett',
      clinicianName: 'Dr. Rachel Moore',
      location: 'East Clinic',
      type: 'Follow-up',
      description: 'Initial mental health interview...',
      notes: 'Patient appears anxious...',
    },
  },
  {
    tenantId: 'TNT-38204',
    domain: 'appointment',
    eventId: 'APT-02011',
    patientId: 'P99887',
    internalStatus: 'Pending',
    status: 'completed',
    start: new Date('2025-09-15T12:15:00+12:00'),
    end: new Date('2025-09-15T13:00:00+12:00'),
    context: {
      projectId: 'ZEDOC-2022-089',
      study: 'Post-Surgery Recovery',
      subStudy: 'Final Clearance',
      // patientName: 'Patient Unknown',
      clinicianName: 'Dr. Angela Brooks',
      location: 'Main Campus',
      type: 'Follow-up',
      // description: "Final check-up post recovery...",
      notes: 'Patient cleared for discharge...',
    },
  },
  {
    tenantId: 'TNT-85031',
    domain: 'appointment',
    eventId: 'APT-02012',
    patientId: 'P56789',
    internalStatus: 'Pending',
    status: 'booked',
    start: new Date('2025-09-15T13:00:00+12:00'),
    end: new Date('2025-09-15T13:30:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-077',
      study: 'Cholesterol Monitoring',
      subStudy: null,
      patientName: 'Emily Zhang',
      clinicianName: 'Dr. Michael Brown',
      location: 'North Clinic',
      type: 'Follow-up',
      // description: "Lab results and medication discussion...",
      notes: 'Possible change to statin dosage...',
    },
  },
  {
    tenantId: 'TNT-64022',
    domain: 'appointment',
    eventId: 'APT-02013',
    patientId: 'P10123',
    internalStatus: 'Active',
    status: 'completed',
    start: new Date('2025-10-09T13:45:00+12:00'),
    end: new Date('2025-10-09T14:15:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-091',
      study: 'Pediatric Checkup',
      subStudy: 'Routine Exam',
      patientName: 'Liam Johnson',
      clinicianName: 'Dr. Sarah Johnson',
      location: 'South Clinic',
      type: 'Follow-up',
      description: 'Routine pediatric health screening...',
      notes: 'Growth within normal range...',
    },
  },
  {
    tenantId: 'TNT-77156',
    domain: 'appointment',
    eventId: 'APT-02014',
    patientId: 'P90876',
    internalStatus: 'Active',
    status: 'no-show',
    start: new Date('2025-08-19T14:30:00+12:00'),
    end: new Date('2025-08-19T15:15:00+12:00'),
    context: {
      projectId: 'ZEDOC-2022-033',
      study: 'Smoking Cessation Program',
      subStudy: 'Progress Check',
      patientName: 'Carlos Rivera',
      clinicianName: 'Dr. James Wilson',
      location: 'Telehealth',
      type: 'Follow-up',
      description: 'Counseling session to assess progress...',
      notes: 'Patient reported 3 weeks smoke-free...',
    },
  },
];

export const medications = [
  {
    tenantId: 'TNT-90213',
    domain: 'drug',
    eventId: 'DRG-00001',
    patientId: 'P10123',
    internalStatus: 'Active',
    status: 'prescribed',
    start: new Date('2025-09-05T09:00:00+12:00'),
    context: {
      name: 'Atorvastatin',
      dosage: 20,
      unit: 'mg',
      frequency: 'once daily',
      notes: 'Take at night with food.',
      patientName: 'Emily Johnson',
      clinicianName: 'Dr. Sarah Kim',
      projectId: 'ZEDOC-2023-201',
    },
  },
  {
    tenantId: 'TNT-73562',
    domain: 'drug',
    eventId: 'DRG-00002',
    patientId: 'P24680',
    internalStatus: 'Pending',
    status: 'dispensed',
    start: new Date('2025-09-07T11:30:00+12:00'),
    context: {
      name: 'Metformin',
      dosage: 500,
      unit: 'mg',
      frequency: 'twice daily',
      notes: 'Take with meals to reduce stomach upset.',
      patientName: 'James Smith',
      clinicianName: 'Dr. Ravi Patel',
    },
  },
  {
    tenantId: 'TNT-38410',
    domain: 'drug',
    eventId: 'DRG-00003',
    patientId: 'P56789',
    internalStatus: 'Active',
    status: 'administered',
    start: new Date('2025-09-16T14:00:00+12:00'),
    context: {
      name: 'Albuterol Inhaler',
      dosage: 2,
      unit: 'puff',
      frequency: 'as needed',
      notes: 'Use during episodes of wheezing or shortness of breath.',
      patientName: 'Sophia Lee',
      clinicianName: 'Dr. Michael Brown',
      projectId: 'ZEDOC-2023-203',
    },
  },
  {
    tenantId: 'TNT-62874',
    domain: 'drug',
    eventId: 'DRG-00004',
    patientId: 'P67891',
    internalStatus: 'Pending',
    status: 'canceled',
    start: new Date('2025-09-15T10:30:00+12:00'),
    context: {
      name: 'Amoxicillin',
      dosage: 250,
      unit: 'mg',
      frequency: 'three times daily',
      notes: 'Canceled due to reported allergy.',
      projectId: 'ZEDOC-2023-204',
      clinicianName: 'Dr. Lisa Williams',
    },
  },
];

export const procedures = [
  {
    tenantId: 'TNT-52931',
    domain: 'procedure',
    eventId: 'PRC-00001',
    patientId: 'P10001',
    internalStatus: 'Active',
    status: 'booked',
    start: new Date('2025-09-03T08:30:00+12:00'),
    end: new Date('2025-09-03T09:15:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-301',
      type: 'Routine screening',
      description: 'Scheduled colonoscopy for routine health check.',
      location: 'Central Hospital - Endoscopy Unit',
      notes: 'Patient must fast for 12 hours before procedure.',
      patientName: 'Daniel Carter',
      clinicianName: 'Dr. Maria Lopez',
    },
  },
  {
    tenantId: 'TNT-84722',
    domain: 'procedure',
    eventId: 'PRC-00002',
    patientId: 'P10002',
    internalStatus: 'Pending',
    status: 'no-show',
    start: new Date('2025-09-07T10:00:00+12:00'),
    end: new Date('2025-09-07T11:30:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-302',
      type: 'Orthopedic evaluation',
      description: 'Patient did not arrive for scheduled knee arthroscopy.',
      location: 'East Clinic - Surgery Ward',
      notes: 'Follow-up call required to reschedule.',
      patientName: 'Laura Mitchell',
      clinicianName: 'Dr. Anthony Clark',
    },
  },
  {
    tenantId: 'TNT-66310',
    domain: 'procedure',
    eventId: 'PRC-00003',
    patientId: 'P10003',
    internalStatus: 'Active',
    status: 'completed',
    start: new Date('2025-09-12T13:00:00+12:00'),
    end: new Date('2025-09-12T15:00:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-303',
      type: 'Cardiac intervention',
      description: 'Cardiac catheterization completed with no complications.',
      location: 'South Clinic - Cardiology Unit',
      notes: 'Patient monitored for 24 hours post-procedure.',
      patientName: 'Oliver Harris',
      clinicianName: 'Dr. Sophia Nguyen',
    },
  },
  {
    tenantId: 'TNT-99284',
    domain: 'procedure',
    eventId: 'PRC-00004',
    patientId: 'P10004',
    internalStatus: 'Pending',
    status: 'aborted',
    start: new Date('2025-09-15T16:00:00+12:00'),
    end: new Date('2025-09-15T16:45:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-304',
      type: 'Ophthalmology surgery',
      description:
        'Cataract surgery aborted due to complications during preparation.',
      location: 'West Medical Center - Eye Surgery Unit',
      notes: 'Reschedule once patient is medically cleared.',
      clinicianName: 'Dr. Robert Davis',
    },
  },
  {
    tenantId: 'TNT-48155',
    domain: 'procedure',
    eventId: 'PRC-00005',
    patientId: 'P10005',
    internalStatus: 'Active',
    status: 'canceled',
    start: new Date('2025-09-20T09:00:00+12:00'),
    end: new Date('2025-09-20T09:45:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-305',
      type: 'Surgical consultation',
      description: 'Appendectomy cancelled by patient request.',
      location: 'North Clinic - Surgery Department',
      notes: 'Patient opted for non-surgical management.',
      patientName: 'Sophia Brown',
      clinicianName: 'Dr. Kevin White',
    },
  },
  {
    tenantId: 'TNT-75429',
    domain: 'procedure',
    eventId: 'PRC-00006',
    internalStatus: 'Pending',
    status: 'booked',
    start: new Date('2025-09-25T14:30:00+12:00'),
    end: new Date('2025-09-25T15:15:00+12:00'),
    context: {
      projectId: 'ZEDOC-2023-306',
      type: 'Emergency CT scan',
      description: 'Urgent brain MRI scan for neurological assessment.',
      location: 'Central Imaging Center',
      notes: 'Remove all metal objects before scan.',
      patientName: 'James Thompson',
      clinicianName: 'Dr. Hannah Patel',
    },
  },
];

export const enrolments = [
  {
    tenantId: 'TNT-90231',
    domain: 'enrolment',
    eventId: 'ENR-00001',
    patientId: 'P20001',
    internalStatus: 'Pending',
    status: 'active',
    context: {
      enrolmentDate: '2025-08-12',
      projectId: 'ZEDOC-2023-401',
      patientName: 'Michael Johnson',
      externalIdentifier: 'MRN-87364',
      sex: 'Male',
      dateOfBirth: '1982-03-15',
      phoneNumber: '+64214567890',
      email: 'michael.johnson@example.com',
    },
  },
  {
    tenantId: 'TNT-51327',
    domain: 'enrolment',
    eventId: 'ENR-00002',
    patientId: 'P20002',
    internalStatus: 'Pending',
    status: 'inactive',
    context: {
      enrolmentDate: '2025-07-25',
      projectId: 'ZEDOC-2023-402',
      patientName: 'Emily Carter',
      externalIdentifier: 'NHI-U83920',
      sex: 'Female',
      dateOfBirth: '1990-11-02',
      phoneNumber: '+64217654321',
      email: 'emily.carter@example.com',
    },
  },
  {
    tenantId: 'TNT-72491',
    domain: 'enrolment',
    eventId: 'ENR-00003',
    patientId: 'P20003',
    internalStatus: 'Pending',
    status: 'active',
    context: {
      enrolmentDate: '2025-09-01',
      projectId: 'ZEDOC-2023-403',
      patientName: 'Lucas Thompson',
      externalIdentifier: 'MRN-55210',
      sex: 'Male',
      dateOfBirth: '1978-06-28',
      phoneNumber: '+64271112222',
      email: 'lucas.t@example.com',
    },
  },
  {
    tenantId: 'TNT-34985',
    domain: 'enrolment',
    eventId: 'ENR-00004',
    patientId: 'P20004',
    internalStatus: 'Pending',
    status: 'deceased',
    context: {
      enrolmentDate: '2025-06-18',
      projectId: 'ZEDOC-2023-404',
      patientName: 'Charlotte Green',
      externalIdentifier: 'NHI-Z67231',
      sex: 'Female',
      dateOfBirth: '1950-01-10',
      phoneNumber: '+64228889999',
      email: 'charlotte.green@example.com',
    },
  },
  {
    tenantId: 'TNT-61572',
    domain: 'enrolment',
    eventId: 'ENR-00005',
    patientId: 'P20005',
    internalStatus: 'Pending',
    status: 'active',
    context: {
      enrolmentDate: '2025-09-10',
      projectId: 'ZEDOC-2023-405',
      patientName: 'Oliver White',
      externalIdentifier: 'MRN-98012',
      sex: 'Male',
      dateOfBirth: '1985-12-05',
      phoneNumber: '+64293334444',
      email: 'oliver.white@example.com',
    },
  },
];
